import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GridApi, } from 'ag-grid-community';
import { AgGridTableState } from '../../state/models/crm-person-views';


@Injectable({ providedIn: 'root' })
export class AgGridStateService {
  private gridStates = new Map<string, BehaviorSubject<AgGridTableState>>();

  /**
   * Atualiza o estado da tabela e notifica quem estiver ouvindo.
   */
  updateState(key: string, gridApi: GridApi): void {
    if (!gridApi) return;

    const state: AgGridTableState = {
      filters: gridApi.getFilterModel(),
      columns: gridApi.getColumnState(),
    };

    if (!this.gridStates.has(key)) {
      this.gridStates.set(key, new BehaviorSubject<AgGridTableState>(state));
    } else {
      this.gridStates.get(key)!.next(state);
    }
  }

  /**
   * Retorna o BehaviorSubject observável para o estado da tabela.
   */
  getState$(key: string = 'defaultTable'): BehaviorSubject<AgGridTableState> {
    if (!this.gridStates.has(key)) {
      this.gridStates.set(key, new BehaviorSubject<AgGridTableState>({
        filters: {},
        columns: [],
      }));
    }
    return this.gridStates.get(key)!;
  }

  /**
   * Aplica o último estado salvo na grid, se houver.
   */
  restoreState(key: string, gridApi: GridApi): void {
    const state = this.gridStates.get(key)?.getValue();
    if (!state) return;

    gridApi.applyColumnState({ state: state.columns as any, applyOrder: true });
    gridApi.setFilterModel(state.filters);
  }

  /**
   * Limpa o estado armazenado na memória.
   */
  clearState(key: string): void {
    this.gridStates.delete(key);
  }
}
